'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';

interface CategoryMobileSelectProps {
  filteredThemes: { header: string | null; slug: { current: string } }[];
  activeCategory?: string | null;
}

export default function CategoryMobileSelect({
  filteredThemes,
  activeCategory,
}: CategoryMobileSelectProps) {
  const router = useRouter();
  const [selectValue, setSelectValue] = useState<string>(activeCategory || '');
  const handleSelection = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const tierValue = e.target.value;
    setSelectValue(tierValue);
    router.push(`/themes/${tierValue}`);
  };

  return (
    <div className="mobileCategoryList">
      <Form.Select
        aria-label="Select a theme category"
        value={selectValue}
        onChange={handleSelection}
      >
        {filteredThemes?.map((item, index) => (
          <option
            value={item.slug.current}
            key={index}
            aria-label={`Category: ${item.header}`}
          >
            {item.header}
          </option>
        ))}
      </Form.Select>
    </div>
  );
}
